/** MIME type for copying Notch canvas elements to the system clipboard (see ElementCopyPasteStore). */
export const NOTCH_ELEMENTS_CLIPBOARD_MIME = 'text/notch-elements-v1'
